import { ProtectedImg } from "../components/ProtectedMedia";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, abs, money, errMsg, TYPE_LABELS } from "../lib/api";
import { PageHeader, Loading } from "../components/PageHeader";

export default function Gallery() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/products", { params: { type: "physical_art,digital_art" } }).then((r) => setItems(r.data))
      .catch((e) => { setItems([]); toast.error(errMsg(e)); });
  }, []);
  return (
    <div data-testid="gallery-page">
      <PageHeader eyebrow="Gallery" title="Illustrations of a dreaming forest">
        Original charcoal drawings and digital prints. Select any work to view details and collect it.
      </PageHeader>
      <div className="wb-container">
        {!items ? <Loading /> : (
          <div className="columns-1 gap-8 sm:columns-2 lg:columns-3 py-6" data-testid="gallery-grid">
            {items.map((p, i) => (
              <Link
                key={p.id} to={`/product/${p.slug}`} data-testid="gallery-item"
                className="group relative mb-8 block break-inside-avoid fade-up" style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="art-frame">
                  <ProtectedImg src={abs(p.image_urls[0])} alt={p.title} loading="lazy" className={`w-full h-auto ${p.sold_out ? "grayscale opacity-60" : ""}`} />
                  <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{ background: "linear-gradient(to top, rgba(8,9,10,.9), transparent 60%)" }}>
                    <div className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-[#D4AF37]">{TYPE_LABELS[p.type]}</div>
                    <div className="mt-1 font-display text-2xl text-[#F4F4F6]">{p.title}</div>
                  </div>
                  <span className="price-tag absolute right-4 top-4" data-testid="gallery-item-price">{p.sold_out ? "Sold out" : money(p.price)}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
